import React from "react";
import { Modal, Pressable, StyleSheet, Text, View } from "react-native";

export default function ReportModalSheet({
  visible,
  onClose,
  children,
  contentStyle,
  Icon,
  title,
  iconColor = "#5423B5",
}) {
  return (
    <Modal visible={visible} transparent animationType="slide" onRequestClose={onClose}>
      <Pressable style={styles.backdrop} onPress={onClose}>
        <Pressable style={[styles.sheet, contentStyle]} onPress={() => {}}>
          <View style={styles.heading}>
            <View style={styles.icon}>
              <Icon width={18} height={18} customColor={iconColor} />
            </View>
            <Text style={styles.title}>{title}</Text>
          </View>
          <View style={styles.divider} />
          {children}
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="Tutup"
            onPress={onClose}
            style={styles.closeButton}
          >
            <Text style={styles.closeButtonText}>Tutup</Text>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: { flex: 1, justifyContent: "flex-end", backgroundColor: "rgba(0,0,0,0.42)" },
  sheet: { maxHeight: "76%", paddingHorizontal: 16, paddingTop: 20, paddingBottom: 10, borderTopLeftRadius: 18, borderTopRightRadius: 18, backgroundColor: "#FFFFFF" },
  heading: { minHeight: 26, flexDirection: "row", alignItems: "center", gap: 8 },
  icon: { width: 22, height: 22, borderRadius: 5, backgroundColor: "#F0E9FF", alignItems: "center", justifyContent: "center" },
  title: { color: "#171717", fontFamily: "Archivo-Bold", fontSize: 12 },
  divider: { height: 1, marginTop: 12, marginBottom: 14, backgroundColor: "#EEEEEE" },
  closeButton: { minHeight: 42, marginTop: 8, borderRadius: 22, backgroundColor: "#F0E9FF", alignItems: "center", justifyContent: "center" },
  closeButtonText: { color: "#6724E2", fontFamily: "Archivo-Bold", fontSize: 11 },
});